import { render, staticRenderFns } from "./ViewUserEvents.vue?vue&type=template&id=4ac62c00&"
import script from "./ViewUserEvents.vue?vue&type=script&lang=js&"
export * from "./ViewUserEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports